import {Component, input, output, signal} from '@angular/core';
import {Message} from "primeng/message";
import {Button, ButtonSeverity} from 'primeng/button';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'ta-toast',
  imports: [
    Message,
    Button
  ],
  templateUrl: './ta-toast.component.html',
  styleUrl: './ta-toast.component.scss'
})
export class TaToastComponent {
  visible = input<boolean>(true);
  title = input<string>("");
  body = input<string>("");
  size = input<"regular" | "max">("regular");
  severity = input<"error" | "success" | "info" | "warn" | "secondary" | "contrast">("info");
  closable = input<boolean>(true);
  onClose = output();

  // Icon mapping
  public readonly iconMap: Record<string, string> = {
    'info': 'fa-light fa-info-circle fa-lg',
    'success': 'fa-light fa-circle-check fa-lg',
    'warn': 'fa-light fa-warning fa-lg',
    'error': 'fa-light fa-exclamation-circle fa-lg',
    'default': 'fa-light fa-info-circle fa-lg',
  };
  public readonly severityMap: Record<string, ButtonSeverity> = {
    'info': 'info',
    'success': 'success',
    'warn': 'warn',
    'error': 'danger',
  };

  //Have to reimplement close functionality to fix formatting of close 'x'
  closeToast(): void {
    this.onClose.emit();
  }
}
